<div class="position-relative">
  <a (click)="onPopupClose()" class="close mat-modal-close"><i class="material-icons">close</i></a>
  <mat-tab-group animationDuration="0ms" dynamicHeight [(selectedIndex)]="TabIndex"
    (selectedTabChange)="changeTab($event)" class="mat-tab-secondary">
    <mat-tab label="List">
      <ng-template matTabContent>
        <div class="align-items-center">
          <div class="search-input pl-2 mb-2">
            <input type="text" type="search" [(ngModel)]="SearchValue" (keyup.backspace)="OnBlankInput($event)"
              class="form-control field-search W-98" placeholder="Press ENTER to search" name="search2" maxlength="200"
              (keyup.enter)="onSearch()" (input)="onInputChange($event)">
          </div>
        </div>
        <div [ngClass]="{'paddingMax' : this.showloader}">
        <app-page-tiny-loader *ngIf="this.showloader" (loaderClosed)="onLoaderClosed()"></app-page-tiny-loader>
      </div>
        <div class="table-responsive table-sticky" *ngIf="!this.showloader">
          <table class="table table-default table-hover">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Created Date</th>
                <th>Manager</th>
                <th>Business Unit</th>
                <th>Location</th>
                <th>Location Info</th>
                <th class="text-right">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cost of CostlistData; let i = index;">
                <td matTooltip="{{cost.name}}" *ngIf="!isNotSelect">
                  <a style="cursor: pointer;" role="button" href="javascript:void(0);" (click)="SelectCost(cost)">
                    {{ cost.name?.length > 20 ? cost.name?.substring(0, 20) + '...' : cost.name }}
                  </a>
                </td>
                <td matTooltip="{{cost.name}}" *ngIf="isNotSelect">
                  {{ cost.name?.length > 20 ? cost.name?.substring(0, 20) + '...' : cost.name }}
                </td>
                <td><span matTooltip="{{cost.description}}">
                    {{ cost.description?.length > 30 ? cost.description?.substring(0, 30) + '...' : cost.description
                    }}</span></td>
                <td><span>{{ formatDate(cost.foundedDate) }}</span></td>
                <td><span matTooltip="{{cost.managerName}}">{{ cost.managerName?.length > 20 ?
                    cost.managerName?.substring(0, 20) + '...' : cost.managerName }}</span></td>
                <td><span matTooltip="{{cost.bussinessUnitName}}">{{ cost.bussinessUnitName == null ? '-' :
                    cost.bussinessUnitName?.length > 20 ? cost.bussinessUnitName?.substring(0, 20) + '...' :
                    cost.bussinessUnitName }}</span></td>
                <td><span matTooltip="{{cost.location}}">{{ cost.location == null ? '-' : cost.location?.length > 20 ?
                    cost.location?.substring(0, 20) + '...' : cost.location }}</span></td>
                <td><span *ngIf="cost.locationInfo !='  , ,  '" matTooltip={{cost.locationInfo}}>{{
                    cost.locationInfo?.length > 30 ? cost.locationInfo.substring(0, 30) + '...' : cost.locationInfo
                    }}</span>
                  <span *ngIf="cost.locationInfo=='  , ,  '">-</span>
                </td>
                <td class="text-right">
                  <div class="d-flex align-items-center justify-content-end">
                    <span class="material-icons text-primary material-md-icon pointer" matTooltip="Edit"
                      (click)="Edit(cost)">edit</span>
                    <span class="material-icons closeicon pointer material-md-icon ml-2" matTooltip="Delete"
                      (click)="clickMethod(cost)">close</span>
                  </div>
                </td>
              </tr>
              <tr>
                <td class="nofoundTxt" colspan="8" *ngIf="CostlistData.length < 1">
                  <h1><i class="far fa-frown mr-1"></i>&nbsp;No data found!</h1>
                </td>
              </tr>
            </tbody>
          </table>

        </div>
        <mat-paginator #paginator *ngIf="CostlistData?.length > 0" [showFirstLastButtons]="true"
          [length]="Paginator.Length" [pageSize]="Paginator.PageSize" [pageSizeOptions]="Paginator.PageSizeOptions"
          (page)="setPagination($event)">
        </mat-paginator>
      </ng-template>
    </mat-tab>

    <mat-tab label="{{ Operation }}">
      <ng-template matTabContent>
        <div class="p-3">
          <form [formGroup]="formGroup" (ngSubmit)="onSubmit()">
            <div class="row">
              <div class="col-sm-12">
                <label class="form-label">Name <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" id="name" placeholder="Enter Name" name="Name" (paste)="handlePaste($event, 1)"
                    pattern="^(?!\s*$).+" (keypress)="removeSpaces($event)" (keypress)="allowAlphaNumericHyphen($event)"
                    formControlName="Name" class="field-control" maxlength="50">
                </mat-form-field>
                <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted">
                  <span *ngIf="formGroup.get('Name')?.errors?.['required']">Name is required</span>
                </div>
              </div>
              <div class="col-sm-8">
                <label class="form-label">Description <span class="req">*</span></label>
                <mat-form-field appearance="outline" class="w-100">
                  <textarea matInput id="Description" placeholder="Enter Description." name="Description" (keypress)="removeSpaces($event)"
                  formControlName="Description" cdkAutosizeMinRows="3" class="field-control resizeno"
                    maxlength="200"></textarea>
                </mat-form-field>
                <div class="errorMsg ErrorDesMsgSetting" *ngIf="Submitted">
                  <span *ngIf="formGroup.get('Description')?.errors?.['required']">Description is required</span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="form-label"> Manager </label>
                  <mat-form-field appearance="outline" class="w-100 material-readonly">
                    <input type="text" id="Manager" placeholder="Enter Manager or space" name="ManagerId" matInput formControlName="ManagerId"
                    [ngClass]="{ 'is-invalid': Submitted && formGroup.get('ManagerId')?.value??0 == 0 }"
                    [matAutocomplete]="auto1" (input)="filterManager($event)" class="field-control blackColor" readonly="true">
                    <mat-autocomplete #auto1="matAutocomplete" [displayWith]="displayWithManager"
                    (closed)="onClosedCallback(filteredManagers,ManagerListData, formGroup, 'ManagerId', 'fullName')"
                    (optionSelected)="onSelectionCallback($event, formGroup, 'ManagerId', 'fullName')">
                      <mat-option *ngFor="let option of filteredManagers" [value]="option"
                      [matTooltip]="option?.fullName?.length > 45 ? option?.fullName : ''">
                        {{option?.fullName?.length > 45 ? option?.fullName?.substring(0, 45) + '...' : option.fullName }}
                      </mat-option>
                      <mat-option *ngIf="filteredManagers?.length === 0" disabled class="no-data-option">
                        Manager Not Found!
                      </mat-option>
                    </mat-autocomplete>
                </mat-form-field>
                  <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted">
                    <span *ngIf="formGroup.get('ManagerId')?.errors?.['required']">Manager is required</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="form-label">Select Location/Business Unit <span class="req">*</span></label>
                  <mat-radio-group formControlName="selectedOption" name="selectedOption" (change)="resetIds()" required="" class="horizontal-radio-group">
                    <mat-radio-button value="location">Location</mat-radio-button>
                    <mat-radio-button value="businessUnit">Business Unit</mat-radio-button>
                  </mat-radio-group>

                  <div class="errorMsg" *ngIf="Submitted && selectedOption == ''">
                    <span *ngIf="selectedOption == ''">Please select Location/Business Unit</span>
                  </div>
                </div>
              </div>
              <div class="col-md-5" *ngIf="selectedOption === 'location'">
                <div class="form-group">
                  <label class="form-label">Location <span class="req">*</span><app-on-page-loader [isLoading]="IsLocationLoading"></app-on-page-loader>
                    <span class="text-primary float-right ml-auto" matTooltip="If you know the name then please type it otherwise press space">
                      <i class="info-icon" ><img src="assets/images/info-icon.svg" /></i>
                   </span>
                  </label>
                  <div class="input-group-mat">
                    <mat-form-field   appearance="outline" class="w-100">
                      <input type="text" id="Location" placeholder="Enter Location or space" name="LocationId" matInput formControlName="LocationId"
                      [matAutocomplete]="auto" (input)="filterLocations($event)" class="field-control" required
                      [ngClass]="{ 'is-invalid': Submitted && formGroup.get('LocationId')?.value == 0 }">
                      <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayWithLoc"
                      (closed)="onClosedCallback(filteredLocations,LocationListData, formGroup, 'LocationId', 'locationInfo')"
                      (optionSelected)="onSelectionCallback($event, formGroup, 'LocationId', 'locationInfo')">
                        <mat-option *ngFor="let option of filteredLocations; let last = last" [value]="option"
                        [ngStyle]="{'border-bottom': last ? 'none' : '1px solid #ccc'}" class="text-wrap">
                          {{ option.locationInfo }}
                        </mat-option>
                        <mat-option *ngIf="filteredLocations?.length === 0 && IsLocEnter" disabled class="no-data-option">
                          Location Not Found!
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                    <button class="btn btn-md btn-gray input-group-mat-btn" type="button" (click)="location_popup()" appHasPermission="Permissions.Location.Create" matTooltip="Add/Edit Location">
                      <span class="material-symbols-outlined">
                        format_list_bulleted
                        </span></button>
                  </div>
                  <!-- <small *ngIf="noDataLocations" class="no-data-text">{{ConstantNoData}}</small> -->
                  <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted">
                    <div *ngIf="Validlocation && formGroup.get('LocationId')?.errors?.['required']">Location is required</div>
                  </div>
                </div>
              </div>
              <div class="col-md-5" *ngIf="selectedOption === 'businessUnit'">
                <div class="form-group">
                  <label class="form-label">Business Unit <span class="req">*</span><app-on-page-loader [isLoading]="IsBuLoading"></app-on-page-loader>
                    <span class="text-primary float-right ml-auto"
                      matTooltip="If you know the name then please type it otherwise press space">
                      <i class="info-icon"><img src="assets/images/info-icon.svg" /></i>
                    </span>
                  </label>
                  <mat-form-field appearance="outline" class="w-100">
                    <input type="text" id="BU" placeholder="Enter Business unit or space" name="BUId" matInput formControlName="BUId" [matAutocomplete]="auto2"
                      (input)="filterBu($event)" class="field-control" required [ngClass]="{ 'is-invalid': Submitted && ValidBu}">
                    <mat-autocomplete #auto2="matAutocomplete" [displayWith]="displayBU"
                    (closed)="onClosedCallback(filteredBu,BuListData, formGroup, 'BUId', 'name')"
                    (optionSelected)="onSelectionCallback($event, formGroup, 'BUId', 'name')">
                      <mat-option *ngFor="let option of filteredBu; let last = last" [value]="option"
                      [ngStyle]="{'border-bottom': last ? 'none' : '1px solid #ccc'}" class="text-wrap">
                        {{option.name }}
                      </mat-option>
                      <mat-option *ngIf="filteredBu?.length === 0 && IsBuEnter" disabled class="no-data-option">
                        Business Unit Not Found!
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
                  <!-- <small *ngIf="noDataBu" class="no-data-text">{{ConstantNoData}}</small> -->
                  <div class="errorMsg ErrorMsgSetting" *ngIf="Submitted && ValidBu">
                    <span *ngIf="ValidBu && formGroup.get('BUId')?.errors?.['required']">Business Unit is required</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="ml-auto text-right">
              <button type="button" class="btn btn-secondary mr-2" (click)="gotoBack()">Back</button>
              <button type="submit" class="btn btn-primary">{{ Operation }}</button>
            </div>
          </form>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
